import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { getPlayingContentSummary } from './hypertouchDeviceUtils';

const contentTypeBadgeStyle = {
  marginLeft: 8,
  fontSize: 12,
  fontWeight: 'bold',
  color: '#666',
  padding: '2px 8px',
  borderRadius: 8,
  backgroundColor: 'rgba(0, 0, 0, 0.06)',
  textTransform: 'uppercase',
};

export default function PlayingContentLabel({ currentPlayingContent, showTypeBadge = false, emptyFallback = '—' }) {
  const playingContent = getPlayingContentSummary(currentPlayingContent);

  let label = playingContent.label;
  if (!label) {
    if (playingContent.isIdle) {
      label = <Entity entity="noContentPlaying" />;
    } else {
      label = emptyFallback;
    }
  }

  return (
    <>
      {label}
      {showTypeBadge && playingContent.contentType ? (
        <span style={{ ...contentTypeBadgeStyle, marginLeft: playingContent.label ? 8 : 0 }}>
          {playingContent.contentType}
        </span>
      ) : null}
    </>
  );
}
